jQuery(function(){
    var searchButton = jQuery('.searchbox button[type=submit]');
    var searchInput = jQuery('.searchbox input[type=search]');
    var searchInputVisible = false;
    searchButton.click(function(){
        var inputVal = searchInput.val();
        inputVal = jQuery.trim(inputVal).length;
        if(searchInputVisible){
            if(inputVal == 0){
                searchInput.removeClass('open');
                searchInputVisible = false;
                searchInput.attr('aria-expanded', 'false');
                searchInput.attr('tabindex', '-1');
                searchInput.focusout();
                return false;
            }
        }else{
            searchInput.addClass('open');
            searchInputVisible = true;
            searchInput.attr('aria-expanded', 'true');
            searchInput.attr('tabindex', '0');
            setTimeout(function() {
                searchInput.focus();
            },500);
            return false;
        }
    });
    jQuery(document).click(function(event){
        var target = jQuery(event.target);
        if(!target.closest('.searchbox').length && searchInput.hasClass('open')){
            searchInput.removeClass('open');
            searchInputVisible = false;
            searchInput.attr('aria-expanded', 'false');
            searchInput.attr('tabindex', '-1');
            searchInput.focusout();
        }
    });

    if( jQuery('.navigation-wrapper').length > 0){
		var navigation = jQuery('.navigation-wrapper');
		var header = jQuery('header.header');
		var navTopPosition = navigation.offset().top;
		var navHeight = navigation.height() + 1;
		var headerHeight = header.height();

		window.addEventListener('scroll', scrollSearchbox);
		function scrollSearchbox(){
			var currentScrollPos = jQuery(window).scrollTop();
			if( currentScrollPos > navTopPosition ){
				navigation.addClass('sticky');
				header.css('height', headerHeight);
				jQuery('#site-search-topbar .site-search form').appendTo( jQuery('#site-search-nav') );
			}else if(navigation.hasClass('sticky')){
				navigation.removeClass('sticky');
				header.css('height', 'auto');
				jQuery('#site-search-nav form').appendTo( jQuery('#site-search-topbar .site-search') );
			}
		}
	}
});